import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
// import { Localization } from "../../core/localization/Localization";



@Directive({ selector: '[inputtype]' })
export class InputtypeDirective {
  private listOfNumberTypes: string[] = ['onlynumber', 'nonnegative', 'onlynegative', 'nodecimal', 'decimal', 'roundoff2'];
  private listOfTextType: string[] = ['capitalise', 'textonly', 'nospecailchar', 'notallowspace', 'email'];
  constructor(private element: ElementRef, private control: NgControl/* , private localization: Localization */) {
  }
  @Input() inputtype: string;
  private givenListType: string[];
  private negativeSign = '-';
  private DecimalSeperator = '.';
  includesArrayValue(baseArray: string[], inputArray: string[]): boolean {

    return inputArray.every(function (value) {
      return (baseArray.indexOf(value) >= 0);
    });

  }

  @HostListener('blur', ['$event']) onblur(event) {
    // debugger;
    const e = <KeyboardEvent>event;
    this.givenListType = this.inputtype.replace(/ /g, '').split(',');
    if (this.includesArrayValue(this.listOfNumberTypes, this.givenListType)) {
      this.OnBlurFunction(e);
    }
    if (this.includesArrayValue(this.listOfTextType, this.givenListType)) {
      this.OnBlurFunction(e);
    }

  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent>event;
    if (!this.inputtype) {
      this.inputtype = '';
    }
    this.givenListType = this.inputtype.replace(/ /g, '').split(',');
    if (this.includesArrayValue(this.listOfNumberTypes, this.givenListType)) {
      this.InputTypeNumberValidation(e);
    }
    if (this.includesArrayValue(this.listOfTextType, this.givenListType)) {
      this.InputTextType(e);
    }

    if (this.givenListType.includes(this.listOfNumberTypes[5])) {
      this.RestrictRoundoff2(e);
    }
  }

  RestrictRoundoff2(e: KeyboardEvent) {
    const input = (<HTMLInputElement>e.target);
    let valueEntered: string = input.value;
    valueEntered = valueEntered ? valueEntered : '';
    if (valueEntered.indexOf(this.DecimalSeperator) >= 0) {
      const arr = valueEntered.split(this.DecimalSeperator);
      if (
        // Allow function keys
        (e.keyCode >= 112 && e.keyCode <= 123) ||
        // allow minus - onlynumber,only negative
        (input.selectionStart < 1 && (this.givenListType.includes(this.listOfNumberTypes[0])
         || this.givenListType.includes(this.listOfNumberTypes[2])) &&
          e.key === this.negativeSign && (valueEntered.indexOf(this.negativeSign) === -1 || input.selectionEnd === valueEntered.length)) ||
        // Decimal Seperator - Region
        (!this.givenListType.includes(this.listOfNumberTypes[3])
        && valueEntered.indexOf(this.DecimalSeperator) === -1 && this.DecimalSeperator === e.key) ||
        // Allow default options like delete..
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39) || (input.selectionEnd > input.selectionStart) ||
        // allow input before decimal seperator
        (valueEntered.indexOf(this.DecimalSeperator)  >=  input.selectionStart)) {
        // let it happen, don't do anything
        return;
      }
      if (arr[1].length > 1) {
        e.preventDefault();
      }
    }
  }

  @HostListener('keyup', ['$event']) onkeyup(event) {
    const e = <KeyboardEvent>event;
    if (!this.inputtype) {
      this.inputtype = '';
    }
    this.givenListType = this.inputtype.replace(/ /g, '').split(',');
    if (this.includesArrayValue(this.listOfTextType, this.givenListType)) {
      this.InputTextType(event);
    }
  }

  InputTextType(e: KeyboardEvent): void {

    if (this.givenListType.includes(this.listOfTextType[2])) {
      if (!this.omit_special_char(e)) {
        e.preventDefault();
        return;
      }
    }

    if (this.givenListType.includes(this.listOfTextType[1])) {
      if (Number(e.key) > 0) {
        e.preventDefault();
        return;
      }
    }
    if (this.givenListType.includes(this.listOfTextType[0])) {
      let value = this.element.nativeElement.value;
      value = value ? value.toUpperCase() : '';
      this.control.control.setValue(value);
    }
    if (this.givenListType.includes(this.listOfTextType[3])) {
      if (e.which === 32) {
        e.preventDefault();
      }
    }
  }

  OnBlurFunction(e: KeyboardEvent) {
    const input = (<HTMLInputElement>e.target);
    const valueEntered: string = input.value ? input.value : '';
    if (this.givenListType.includes(this.listOfNumberTypes[4])) {
      if (!valueEntered.includes(this.DecimalSeperator)) {
        this.control.control.setValue(valueEntered.trim() === '' ? '' : valueEntered.toString() + this.DecimalSeperator + '00');
      } else {
        const splitVal = valueEntered.split(this.DecimalSeperator);
        if (splitVal[1].length > 2) {
          this.control.control.setValue(parseFloat(valueEntered).toFixed(2));
        }
      }
    }
    if (this.givenListType.includes(this.listOfTextType[4])) {
      if (!this.validateEmail(valueEntered)) {
        if (valueEntered.trim() !== '') {
          this.control.control.setErrors({ 'incorrect': true });
        }
      }
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  InputTypeNumberValidation(e: KeyboardEvent): void {
    const input = (<HTMLInputElement>e.target);
    let valueEntered: string = input.value;
    valueEntered = valueEntered ? valueEntered : '';
    if (
      // Allow function keys
      (e.keyCode >= 112 && e.keyCode <= 123) ||
      // allow minus - onlynumber,only negative
      (input.selectionStart === 0 && (this.givenListType.includes(this.listOfNumberTypes[0])
       || this.givenListType.includes(this.listOfNumberTypes[2])) &&
        e.key === this.negativeSign && (valueEntered.indexOf(this.negativeSign) === -1 || input.selectionEnd === valueEntered.length)) ||
      // Decimal Seperator - Region
      (!this.givenListType.includes(this.listOfNumberTypes[3])
       && valueEntered.indexOf(this.DecimalSeperator) === -1 && this.DecimalSeperator === e.key) ||
      // Allow default options like delete..
      [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) ||
      // non negative , includes zero
      (this.givenListType.includes(this.listOfNumberTypes[1]) && e.key === this.negativeSign)
    ) {
      e.preventDefault();
    }

  }

  omit_special_char(e) {
    // Allow function keys
    const result = (e.keyCode >= 112 && e.keyCode <= 123) ||
      // Allow default options like delete..
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Space
      (e.keyCode === 32) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39) ||
      (/[^a-zA-Z0-9]/.test(e.key) === false);
    return result;
  }

}
